import { AlertTriangle, ArrowRight } from "lucide-react";

export function ValidationList({ errors, onJump, limit = 50 }) {
  if (!errors.length) return null;
  const shown = errors.slice(0, limit);
  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50/70 dark:bg-amber-950/20 dark:border-amber-900 p-4" data-testid="qg-validation-list">
      <p className="flex items-center gap-2 text-sm font-semibold text-amber-900 dark:text-amber-200 mb-3">
        <AlertTriangle className="h-4 w-4" />{errors.length} item(s) to resolve before generating the final quotation
      </p>
      <ul className="divide-y divide-amber-100 dark:divide-amber-900 max-h-80 overflow-y-auto">
        {shown.map((e, i) => (
          <li key={`${e.section_key}-${e.item_id || e.group_id || ""}-${e.field}-${i}`}>
            <button type="button" onClick={() => onJump(e)} data-testid={`qg-validation-item-${i}`}
              className="w-full text-left py-2 px-1 flex items-start gap-3 hover:bg-amber-100/60 dark:hover:bg-amber-900/30 rounded transition-colors">
              <span className="text-[11px] font-semibold uppercase tracking-wide text-amber-800 dark:text-amber-300 w-36 shrink-0">{e.section_name}</span>
              <span className="flex-1 text-sm text-slate-800 dark:text-slate-100">
                {e.item_label && <span className="font-medium">{e.item_label}: </span>}{e.message}
              </span>
              <ArrowRight className="h-4 w-4 text-amber-700 shrink-0 mt-0.5" />
            </button>
          </li>
        ))}
      </ul>
      {errors.length > limit && <p className="text-xs text-amber-800 mt-2">…and {errors.length - limit} more. Fix the issues above to see the rest.</p>}
    </div>
  );
}
